<button
  class="app-table-sort-header-container"
  [class.app-table-sort-header-sorted]="_isSorted()"
  [class.app-table-sort-header-position-before]="arrowPosition === 'before'"
  [attr.tabindex]="_isDisabled() ? null : 0"
  [attr.role]="_isDisabled() ? null : 'button'"
>
  <div class="app-table-sort-header-content">
    <ng-content />
  </div>

  @if (_renderArrow()) {
    <div class="app-table-sort-header-arrows">
      @if (_isSorted()) {
        <svg
          class="app-table-sort-header-icon"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [class.app-table-sort-header-icon-desc]="isDescSorting"
        >
          <path
            d="M10.5 5.25L7 1.75L3.5 5.25M7 1.75V12.25"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      } @else {
        <svg
          class="app-table-sort-header-icon"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.41667 5.24996L4.08333 2.91663L1.75 5.24996M4.08333 2.91663V11.0833"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            opacity="0.5"
          />
          <path
            d="M7.5835 8.74996L9.91683 11.0833L12.2502 8.74996M9.91683 11.0833V2.91663"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            opacity="0.5"
          />
        </svg>
      }
    </div>
  }
</button>
